import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75,2V7a.75.75,0,0,1-1.5,0V3.81L3.76,13.3H7a.75.75,0,0,1,0,1.5H2a.72.72,0,0,1-.29-.06.63.63,0,0,1-.24-.16.74.74,0,0,1-.2-.38.77.77,0,0,1,0-.15V9A.75.75,0,0,1,2.7,9v3.21l9.49-9.49H9a.75.75,0,0,1,0-1.5h5.15a.42.42,0,0,1,.15,0,.81.81,0,0,1,.42.42.57.57,0,0,1,0,.14s0,0,0,0A.57.57,0,0,1,14.75,2Zm-.62-.74a.82.82,0,0,0-.27,0h.27Zm.62.74v.14a.82.82,0,0,0,0-.27A.57.57,0,0,1,14.75,2Z';
const draw24px =
  'M20.8,4V9a.75.75,0,0,1-1.5,0V5.78L5.76,19.32H9a.75.75,0,0,1,0,1.5H4l-.15,0a.82.82,0,0,1-.38-.2.74.74,0,0,1-.2-.38.77.77,0,0,1,0-.15V15a.75.75,0,0,1,1.5,0v3.22L18.25,4.71H15a.75.75,0,0,1,0-1.5h5A.75.75,0,0,1,20.8,4Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowFullScreenIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowFullScreen')) as IconWithRender;

ArrowFullScreenIcon.displayName = 'ArrowFullScreenIcon';
ArrowFullScreenIcon.propTypes = Icon.propTypes;
ArrowFullScreenIcon.renderIcon = (props) => <ArrowFullScreenIcon {...props} />;
export default ArrowFullScreenIcon;
